exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification[data-v-e1b00ae8]{padding:15px;margin-bottom:15px}.selected[data-v-e1b00ae8]{box-shadow:0 3px 6px #c9c9c9}.bordebutton[data-v-e1b00ae8]{border-bottom:1px solid #e6e6e6;padding-left:12px}.numero[data-v-e1b00ae8]{font-size:14px;padding:3px 7px;width:27px;border-radius:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1b00ae8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrarcontador/Registrarcontador.vue
// module id = 710
// module chunks = 0